var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeleteService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 4.99996H18.3333V6.66663H16.6666V17.5C16.6666 17.721 16.5788 17.9329 16.4225 18.0892C16.2663 18.2455 16.0543 18.3333 15.8333 18.3333H4.16663C3.94561 18.3333 3.73365 18.2455 3.57737 18.0892C3.42109 17.9329 3.33329 17.721 3.33329 17.5V6.66663H1.66663V4.99996H5.83329V2.49996C5.83329 2.27895 5.92109 2.06698 6.07737 1.9107C6.23365 1.75442 6.44561 1.66663 6.66663 1.66663H13.3333C13.5543 1.66663 13.7663 1.75442 13.9225 1.9107C14.0788 2.06698 14.1666 2.27895 14.1666 2.49996V4.99996ZM7.49996 9.16663V14.1666H9.16663V9.16663H7.49996ZM10.8333 9.16663V14.1666H12.5V9.16663H10.8333ZM7.49996 3.33329V4.99996H12.5V3.33329H7.49996Z",
    fill: "#2E353D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteService);
export default __webpack_public_path__ + "static/media/icon_delete_service.d582619ea132e05ee7e838f116554225.svg";
export { ForwardRef as ReactComponent };